// test2493
(2493 && 0);
